import { CSSProperties, FC } from 'react'
import { CSVLink } from "react-csv";
import { IoMdDownload } from "react-icons/io";


interface ICSVDownloaderProps {
  data?: object[];
  filename?: string;
  style?: CSSProperties;
}


export const CSVDownloader: FC<ICSVDownloaderProps> = ({ data = [], filename, style }) => (
  <CSVLink
    data={data}
    target="_blank"
    filename={`${(filename || new Date().toISOString()).split(' ').join('-').toLowerCase()}.csv`}
    style={{
      position: 'absolute',
      right: 0,
      padding: '0.5rem',
      margin: '1rem',
      textDecoration: 'none',
      color: '#999',
      borderRadius: 8,
      border: '1px solid hsl(var(--border))',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
      ...style
    }}
  >
    <IoMdDownload size={24} title="Download as CSV" />
    CSV
  </CSVLink>
)
